import { render, staticRenderFns } from "./TeacherTypeCreate.vue?vue&type=template&id=29644dcc"
import script from "../../controllers/teacher_type/teacher-type-create.js?vue&type=script&lang=js&external"
export * from "../../controllers/teacher_type/teacher-type-create.js?vue&type=script&lang=js&external"
import style0 from "./TeacherTypeCreate.vue?vue&type=style&index=0&id=29644dcc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports